import FlexIncentivesBanner from 'components/RichProfile/MyAccount/AutoReplenishment/FlexIncentivesBanner/FlexIncentivesBanner';

export default FlexIncentivesBanner;
